// NotifyBoardList.js
import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Box } from '@mui/system';
import { Button } from '@mui/material';
import {userInfoRepo} from '../../model/CvoModel';
import AddIcon from '@mui/icons-material/Add';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PageviewIcon from '@mui/icons-material/Pageview';
import FlexyTable from '../common/flexytable/FlexyTable';
import ValueUtil from '../../model/ValueUtil';
import { AppPalette, AppWord, TableColumnType } from '../../model/AppConst';
import { useReactiveVar } from '@apollo/client';
import { NotifyBoardDictionary } from './NotifyBoardGql';
import { ContentHeader, HeaderLeft, HeaderRight } from '../common/CvoStyled';
import SearchBox from '../common/SearchBox';

const NotifyBoardListContainer = styled(Box)({
	flexGrow:1, display:'flex', flexDirection:'column'
});

const Dict = NotifyBoardDictionary.inputMap;
const TableColumns = [
    { id: 'title', label: Dict.title.label, width: 590, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    //{ id: 'contents', label: Dict.contents.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    //{ id: 'textFormat', label: Dict.textFormat.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    { id: 'readIt', label: '확인 여부', width: 80, show: true, option:{align: 'center', print:(r,i,v)=>{return v ? '읽음' : '읽지 않음'}} },
    { id: 'regTime', label: '등록일', width: 100, show: true, option:{align: 'inherit', type: TableColumnType.DATE} },
    //{ id: 'delYn', label: Dict.delYn.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} }
];
const PublicTableColumns = [
    { id: 'title', label: Dict.title.label, width: 600, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    //{ id: 'contents', label: Dict.contents.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    //{ id: 'textFormat', label: Dict.textFormat.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} },
    // { id: 'readIt', label: '확인 여부', width: 80, show: true, option:{align: 'center', print:(r,i,v)=>{return v ? '읽음' : '읽지 않음'}} },
    { id: 'regTime', label: '등록일', width: 100, show: true, option:{align: 'inherit', type: TableColumnType.DATE} },
    //{ id: 'delYn', label: Dict.delYn.label, width: 120, show: true, option:{align: 'inherit', type: TableColumnType.TEXT} }
];

export default function NotifyBoardList({
	records,
    onClickItem,
    onRequestAdd,
    onRequestEdit,
    onRequestRemove,
    onRequestView,
    hideFirstTopButton,
    onRequestReload
}) {
	const sessionInfo = useReactiveVar(userInfoRepo);
    const [search, setSearch] = useState('');


    const onChangeSearch = (text) => {
        setSearch(text);
    };

    const onClickToolOnRow = (toolId, row) => {
        switch(toolId) {
            case AppWord.CMD_REMOVE: onRequestRemove(row); break;
            case AppWord.CMD_EDIT: onRequestEdit(row); break;
            case AppWord.CMD_VIEW: onRequestView(row); break;
            default: return;
        }
    };

    const onSelectItem = (item) => {
		if(onClickItem) onClickItem(item);
    };

	const isAdmin = sessionInfo.signedIn ? ValueUtil.isEtrace(sessionInfo) : false;

    const ViewCommand = {id:AppWord.CMD_VIEW, icon: <PageviewIcon fontSize={AppWord.SMALL} color={AppPalette.PrimaryColor} />};

    return(
        <NotifyBoardListContainer>
            <ContentHeader>
                <HeaderLeft>
                    <SearchBox onChange={onChangeSearch} value={search}/>
                </HeaderLeft>
                <HeaderRight>
				{
					isAdmin
					?
						<Button
							onClick={onRequestAdd}
							variant={AppPalette.VariantContained} color={AppPalette.PrimaryColor}>
							<AddIcon fontSize={AppWord.SMALL} />
							공지사항 추가
						</Button>
					: null
				}
				</HeaderRight>
            </ContentHeader>
            <FlexyTable
                name="notify_board_list"
                uniqueKey="msgSeq"
                columns={sessionInfo.signedIn ? TableColumns : PublicTableColumns}
                records={records}
                search={search}
                tools={isAdmin ? [
                    {id:AppWord.CMD_EDIT, icon:<NoteAltIcon fontSize={AppWord.SMALL} />},
                    {id:AppWord.CMD_REMOVE, icon: <DeleteForeverIcon fontSize={AppWord.SMALL} color={AppPalette.WarnColor} />},
                    ViewCommand
                ] : [
                    ViewCommand
                ]}
                onClickTool={onClickToolOnRow}
				onClickOneRow={onSelectItem}
                hideFirstTopButton={hideFirstTopButton}
                onRequestReload={onRequestReload}
            />
        </NotifyBoardListContainer>
    );

}
